<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: ['data'],
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: [
        'فعال',
        'غیرفعال',
      ],
      datasets: [{
        label: 'نمودار وضعیت تفاهم نامه‌ها',
        data: [this.data.active, this.data.deactive],
        backgroundColor: [
          'rgb(255,255,255,0.27)',
          'rgb(255,255,255,0.17)',
        ],
        borderColor: '#ffffff',
        hoverOffset: 16,
      }],
    }, {
      defaultFontFamily: 'Vazir FD',
      responsive: true,
      maintainAspectRatio: false,
      fontColor: '#ffffff',
      aspectRatio: 1,
      plugins: {
        dataLabels: {
          display: true,
          align: 'bottom',
          backgroundColor: '#ccc',
          borderRadius: 3,
          font: {
            size: 18,
          },
        },
      },
      layout: {
        padding: 16,
      },
      legend: {
        display: true,
        fontSize: 10,
        labels: {
          fontColor: '#ffffff',
          fontFamily: 'Vazir FD',
          fontSize: 12,
        },
      },
    }, [

    ]);
  },
};
</script>

<style lang="scss" scoped>
canvas {
  height: 250px !important;
}
</style>
